import { MutationFunction } from '@tanstack/react-query';

import { get, put } from '..';
import { IModule } from '../../interfaces/customer';
import { buildUrl } from '../../utils';

export const getModules = (domainId?: string) =>
  get(buildUrl(`/v1/customer/domain/${domainId}/module`));

export const getNEOModules = (domainId?: string) =>
  get(buildUrl(`/v1/security/customers/${domainId}/modules`));

export const editModuleApi: MutationFunction<
  IModule,
  { domainId: string; payload: Omit<IModule, 'endDate'> }
> = (variables) =>
  put<IModule>(
    buildUrl(
      `/v1/customer/domain/${variables.domainId}/module/${variables.payload.moduleName}`,
    ),
    variables.payload,
  );

export const editNEOModuleApi: MutationFunction<
  IModule,
  { domainId: string; payload: IModule }
> = (variables) =>
  put<IModule>(
    buildUrl(`/v1/security/customers/${variables.domainId}/modules`),
    variables.payload,
  );
